import { Stack, Typography, Tooltip } from "@mui/material";
import { Localized } from "@fluent/react";

import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import { AddressTypeEnum } from "./commonTypes";

type Props = {
    type: AddressTypeEnum;
};

const iconFor = (t: AddressTypeEnum) => {
    switch (t) {
        case "REGISTERED_OFFICE":
            return <BusinessOutlinedIcon fontSize="small" />;
        case "BILLING":
            return <ReceiptLongOutlinedIcon fontSize="small" />;
        case "SHIPPING":
            return <LocalShippingOutlinedIcon fontSize="small" />;
        case "CORRESPONDENCE":
            return <MailOutlineOutlinedIcon fontSize="small" />;
        case "OTHER":
        default:
            return <LabelOutlinedIcon fontSize="small" />;
    }
};

export const AddressTypeBadge = ({ type }: Props) => {
    return (
        <Tooltip
            title={
                <Localized id={`counterparties-addressType-${type}`}>
                    <span>{type}</span>
                </Localized>
            }
        >
            <Stack
                direction="row"
                spacing={0.7}
                alignItems="center"
                sx={{
                    color: "text.secondary",
                    cursor: "default",
                    "&:hover": {
                        color: "primary.main",
                    },
                    transition: "color 0.2s ease",
                }}
            >
                {iconFor(type)}

                <Typography variant="body2">
                    <Localized id={`counterparties-addressType-${type}`}>
                        <span>{type}</span>
                    </Localized>
                </Typography>
            </Stack>
        </Tooltip>
    );
};